import { Component, Input } from '@angular/core';
import { LineItemKeys } from '@config/keys/line-item.keys';
import { DoodLineItemModel } from '@core/models/line-item.model';

@Component({
  selector: 'app-detail-order-atom',
  templateUrl: './detail-order-atom.component.html',
  standalone: false,
})
export class DetailOrderAtomComponent {
  @Input() lineItems!: DoodLineItemModel[];
  @Input() totalAmount!: number;
  @Input() tips!: number;
  @Input() paidAmount!: number;
  @Input() coupons?: any[];

  get LineItemKeys(): typeof LineItemKeys {
    return LineItemKeys;
  }

  // Get coupon name from line item by matching amount
  // Match coupons to line items by amount, using index as fallback
  getCouponName(lineItem: DoodLineItemModel): string | null {
    if (!this.coupons || lineItem[LineItemKeys.Type] !== 'coupon') {
      return null;
    }
    const lineItemPrice = Math.abs(lineItem[LineItemKeys.Price] ?? 0);

    // Get all coupon line items to find the index
    const couponLineItems = this.lineItems.filter(item => item[LineItemKeys.Type] === 'coupon');
    const couponIndex = couponLineItems.findIndex(item => item === lineItem);

    // First try to match by amount (line item price is negative, coupon amount_off is positive)
    let matchedCoupon = this.coupons.find(
      (c: any) => Math.abs((c.amount_off ?? 0) - lineItemPrice) < 0.01,
    );

    // If no match by amount and we have a valid index, use index matching
    if (!matchedCoupon && couponIndex >= 0 && couponIndex < this.coupons.length) {
      matchedCoupon = this.coupons[couponIndex];
    }

    return matchedCoupon?.name ?? null;
  }

  // Check if line item should be displayed (filter out coupons with 0 amount)
  shouldDisplayLineItem(lineItem: DoodLineItemModel): boolean {
    if (lineItem[LineItemKeys.Type] === 'coupon') {
      const price = lineItem[LineItemKeys.Price] ?? 0;
      return Math.abs(price) > 0.01;
    }
    return true;
  }
}
